<!-- PaidBillModal.vue -->
<template>
  <div class="modal fade" id="paidBillModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-success text-white">
          <h5 class="modal-title text-white">
            <i class="mdi mdi-check-circle me-2"></i>
            Paid Bill Details
          </h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">
          <!-- Payment Status Banner -->
          <div class="alert alert-success border-0 mb-4" role="alert">
            <div class="d-flex align-items-center">
              <div class="flex-shrink-0">
                <i class="mdi mdi-check-circle-outline h2 mb-0"></i>
              </div>
              <div class="flex-grow-1 ms-3">
                <h6 class="alert-heading mb-1">Payment Completed Successfully</h6>
                <p class="mb-0">This bill has been fully paid and processed.</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <address>
                <strong>Bill Prepared for:</strong><br>
                {{ billDetail.description }}<br><br>
                <strong>Date Created:</strong> {{ billDetail.dateCreated }}
              </address>
            </div>
            <div class="col-6 text-end">
              <div class="badge bg-success fs-6 px-3 py-2 mb-3">
                PAID IN FULL
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="py-2 mt-3">
              <h4 class="fw-bold text-primary">{{ billNo }}</h4>
            </div>
          </div>

          <div class="col-12">
            <div class="table-responsive">
              <table class="table table-nowrap">
                <thead class="bg-light">
                <tr>
                  <th style="width: 70px;">No.</th>
                  <th>Customer</th>
                  <th>Description</th>
                  <th class="text-end">Amount</th>
                  <th class="text-center">Status</th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="(item, index) in billInfo" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <div class="d-flex align-items-center">
                      <div class="flex-grow-1">
                        <h6 class="mb-1">{{ maskPhoneNumber(item.customer) }}</h6>
                        <small class="text-muted">Customer</small>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div>
                      <span class="fw-medium">{{ item.feeDescription }}</span>
                    </div>
                  </td>
                  <td class="text-end">
                    <span class="fw-bold text-success">KES {{ formatPrice(item.billTotal) }}</span>
                  </td>
                  <td class="text-center">
                      <span class="badge bg-success">
                        <i class="mdi mdi-check me-1"></i>Paid
                      </span>
                  </td>
                </tr>
                </tbody>

                <tfoot class="bg-light">
                <tr>
                  <td colspan="3" class="border-0 text-end">
                    <strong class="h5">Total Amount:</strong>
                  </td>
                  <td class="border-0 text-end">
                    <h4 class="m-0 fw-bold text-success">
                      KES {{ formatPrice(billDetail.detailAmount) }}
                    </h4>
                  </td>
                  <td class="border-0 text-center">
                      <span class="badge bg-success fs-6">
                        <i class="mdi mdi-check-circle me-1"></i>COMPLETED
                      </span>
                  </td>
                </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <!-- Payment Summary -->
          <div class="row mt-4">
            <div class="col-12">
              <div class="card border-success">
                <div class="card-header bg-light">
                  <h6 class="card-title mb-0">
                    <i class="mdi mdi-cash-multiple me-2"></i>
                    Payment Summary
                  </h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-4">
                      <div class="text-center">
                        <h6 class="text-muted mb-1">Total Billed</h6>
                        <h5 class="mb-0">{{ formatPrice(billDetail.detailAmount) }}</h5>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="text-center">
                        <h6 class="text-muted mb-1">Amount Paid</h6>
                        <h5 class="mb-0 text-success">{{ formatPrice(billDetail.receiptAmount) }}</h5>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="text-center">
                        <h6 class="text-muted mb-1">Balance</h6>
                        <h5 class="mb-0 text-success">{{ formatPrice(billDetail.billBalance || 0) }}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer bg-light">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            <i class="mdi mdi-close me-1"></i>Close
          </button>
          <button @click="printReceipt" class="btn btn-success">
            <i class="mdi mdi-printer me-1"></i>Print Receipt
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaidBillModal",
  props: {
    billDetail: {
      type: Object,
      default: () => ({})
    },
    billInfo: {
      type: Array,
      default: () => []
    },
    billNo: {
      type: String,
      default: ''
    }
  },
  methods: {
    formatPrice(value) {
      if (!value && value !== 0) return 'KES 0.00';
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(value).replace('KES', '').trim();
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') return input;
      const digits = input.replace(/\D/g, '');
      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }
      return input;
    },

    printReceipt() {
      this.$emit('print-receipt');
    }
  }
}
</script>

<style scoped>
.modal-header.bg-success {
  border-bottom: none;
}

.modal-footer.bg-light {
  border-top: 1px solid #dee2e6;
}

.table th {
  font-weight: 600;
  color: #495057;
  background-color: #f8f9fa !important;
}

.badge {
  font-size: 0.75rem;
}

.badge.fs-6 {
  font-size: 0.875rem !important;
}

.card-title {
  color: #495057;
  font-weight: 600;
}

.text-success {
  color: #198754 !important;
}

.bg-success {
  background-color: #198754 !important;
}

.border-success {
  border-color: #198754 !important;
}

.btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.alert-success {
  background-color: rgba(25, 135, 84, 0.1);
  border-color: rgba(25, 135, 84, 0.2);
  color: #0f5132;
}

.h2 {
  font-size: 2rem;
}
</style>